import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CSATConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CSATService } from './api/cSAT.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CSATApiModule {
    public static forRoot(configurationFactory: () => CSATConfiguration): ModuleWithProviders<CSATApiModule> {
        return {
            ngModule: CSATApiModule,
            providers: [ { provide: CSATConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CSATApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CSATApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
